export const calculateAttachement = (
  attachementsCount: number | undefined,
  hypelinksCount: number | undefined,
  filesRelativesCount: number | undefined,
  hyperlinksRelativesCount: number | undefined,
  filesAssetCycleCount: number | undefined = undefined,
  hyperlinksAssetCycleCount: number | undefined = undefined,
) => {
  let att = 0;
  let links = 0;
  if (attachementsCount) att += attachementsCount;
  if (hypelinksCount) links += hypelinksCount;
  if (filesRelativesCount) links += filesRelativesCount;
  if (hyperlinksRelativesCount) links += hyperlinksRelativesCount;
  if (filesAssetCycleCount) links += filesAssetCycleCount;
  if (hyperlinksAssetCycleCount) links += hyperlinksAssetCycleCount;

  return att + links;
};
